export const convertTo12hours = (data: string) => {
    let time: string | number = parseInt(data);
    if (isNaN(time) || time < 0 || time > 2359) {
        return '12:00 AM';
    }
    const hours = Math.floor(time / 100);
    if (hours >= 24) {
        return '12:00 AM';
    }
    const hour12 = hours % 12 || 12;
    const minutes = time % 100;
    const meridiem = hours < 12 ? 'AM' : 'PM';
    if (minutes >= 60) {
        return `${String(hour12).padStart(2, '0')}:00 ${meridiem}`;
    }
    return `${String(hour12).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${meridiem}`;
};

export const phoneNumberFormat = (data: string) => {

    const str1 = data.slice(0, 3)
    const str2 = data.slice(3, 6)
    const str3 = data.slice(6, 10)

    return `(${str1}) ${str2}-${str3}`
}


export const formatDate = (inputDateString: string) => {
    const inputDate = new Date(inputDateString);

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' } as Intl.DateTimeFormatOptions;
    const formattedDate = inputDate.toLocaleDateString('en-US', options);

    return formattedDate;
};

export const formatBalance = (inputBalance: number) => {
    if (inputBalance < 0) {
        return `($${Math.abs(inputBalance).toFixed(2)})`;
    } else {
        return `$${inputBalance.toFixed(2)}`
    }
};
